import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Departamento } from '@rpe/registro-personas-empresas-lib/src/lib/departamentos/departamentos.model';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

export const entityDepartamentosAdapter: EntityAdapter<Departamento> =
  createEntityAdapter<Departamento>({
    selectId: (model) => model.codigo,
    sortComparer: (a: Departamento, b: Departamento): number =>
      a.nombre.toString().localeCompare(b.nombre.toString())
  });

export interface EntityDepartamentosState extends EntityState<Departamento> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityDepartamentosState =
  entityDepartamentosAdapter.getInitialState({
    isLoading: false,
    error: null
  });
